import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { Body2, Caption } from '../Typography';
const Placeholder = ({ icon: Icon, title, subtitle, onClick }) => {
    return (_jsxs(Box, { display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center', flexGrow: 1, onClick: onClick, children: [_jsx(Icon, { fontSize: 'large' }), _jsxs(Box, { ml: 1.5, display: 'flex', flexDirection: 'column', children: [_jsx(Body2, { children: title }), subtitle && _jsx(Caption, { children: subtitle })] })] }));
};
export default Placeholder;
